import BrandService from '@/services/BrandService';
import actions from './actions';
import mutations from './mutations';

const INITIAL_STATE = {
  pendingAsyncStoreActions: [],
  lang: 'pl',
  brand: {
    main_color: '#24262d',
    second_color: '#393c45',
    accent_color: '#42a5f5',
    logo: '',
    registration_additional_data: null,
    additional_styles: '',
    logo_above_form: '',
    forms: []
  },
  support_email: 'devs@telestrada.pl',
};

const getters = {
  pendingAsyncStoreActions: state => ({
    includes(pendingActions = []) {
      const _pendingActions = pendingActions;
      return state.pendingAsyncStoreActions.some(a => _pendingActions.includes(a));
    },
  }),
  brandTheme: state => BrandService.generateBrandTheme(state.brand),
  brandLogo: state => state.brand.logo,
  logoAboveForm: state => state.brand.logo_above_form,
  forms: state => state.brand.forms,
  brandRegistrationAdditionalData: state => state.brand.registration_additional_data,
  lang: state => state.lang,
  supportEmail: state => state.support_email,
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
export default {
  namespaced: true,
  state: INITIAL_STATE,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/global/index.js